import RptHome from './../views/rpt/RptHome.vue'
import TemporaryPage from './../views/rpt/TemporaryPage.vue'

const rpt = [
  {
    path: '/rpt',
    component: RptHome,
    meta: { auth: true }    
  },
  {
    path: '/temporary-page:link',
    name: 'TemporaryPage',
    component: TemporaryPage,
    meta: { auth: true }    
  }
]

export default rpt